module.exports = __webpack_public_path__ + "img/card3.155e3c77.png";